import { LinkButton } from '#components/atoms/buttons/link-button/LinkButton.tsx';
import { PageHeader } from '#components/patterns/page-header/PageHeader.tsx';
import { Spacer } from '#components/patterns/spacer/Spacer.tsx';
import { useAppLocation } from '#hooks/useAppLocation.ts';
import { useUrlParams } from '#hooks/useUrlParams.ts';
import { TargetTypeSelect } from '#screens/logs/audit/export/form/target-type-select/TargetTypeSelect.tsx';
import { validateTargetOptionParam } from '#screens/logs/audit/form-types.ts';
import { LogFilterPill } from '#screens/logs/audit/log-filter-pill/LogFilterPill.tsx';
import styles from './AuditLogsPageHeader.module.css';

const PARAM_SCHEMA = {
  cursor: 'scalar',
  targetType: 'scalar',
  targetId: 'scalar',
} as const;

export function AuditLogsPageHeader() {
  const location = useAppLocation();
  const [params, setParams] = useUrlParams(PARAM_SCHEMA);
  const { targetType: targetTypeParam, targetId } = params;
  const validatedTargetTypeParam = validateTargetOptionParam(targetTypeParam);
  function clearTargetIdFilter() {
    setParams({ cursor: undefined, targetId: undefined });
  }

  const csvExportButton = (
    <LinkButton
      className="shrink-0"
      size="small"
      to={{
        pathname: 'export',
        search: location.search,
      }}
      state={{ from: location }}
    >
      Export CSV
    </LinkButton>
  );

  const filterPill =
    targetId ? <LogFilterPill className="grow-0" onClick={clearTargetIdFilter} targetId={targetId} /> : null;

  const targetTypeSelect = (
    <TargetTypeSelect
      className={styles.AuditLogsPageHeader_targetTypeSelect}
      label="Filter to:"
      visuallyHideLabel={true}
      value={validatedTargetTypeParam}
      onChange={(newValue) => {
        if (newValue) {
          // Clear the cursor when changing target types
          setParams({ cursor: undefined, targetType: newValue });
        }
      }}
    />
  );

  return (
    <PageHeader title="Audit logs" preventTitleWrap={true} className={styles.AuditLogsPageHeader} wrapAtPx={530}>
      <div className={styles.AuditLogsPageHeader_pillContainer___wide}>
        {targetId ? filterPill : <div />}
        <Spacer className="mw-0 shrink-0">
          {targetId ? null : targetTypeSelect}
          {csvExportButton}
        </Spacer>
      </div>
      <div className={styles.AuditLogsPageHeader_pillContainer___narrow}>
        {csvExportButton}
        {targetId ? filterPill : targetTypeSelect}
      </div>
    </PageHeader>
  );
}
